<div class="w-[100%] h-[100%]">
  <div
    class="w-[100%] h-[auto] flex justify-around items-center px-[10px] pt-[25px]"
  >
    <div class="!cursor-pointer relative">
      <button
        class="flex bg-[#E76B3F] text-[#F1F3F5] w-[7vw] h-[5.5vh] justify-center items-center flex-shrink-0 rounded-[4px] font-semibold text-[14px] relative z-10"
        style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
        [ngClass]="{
          'bg-[#F1F3F5] !text-[#E76B3F] border border-[#E76B3F]':
            activeBtn !== 'call_now',
          'bg-[#E76B3F] !text-[#F1F3F5]': activeBtn === 'call_now'
        }"
        (click)="changeBtn('call_now')"
      >
        Call Now
      </button>

      <!-- Pseudo-element below the button to show cursor -->
      <div
        *ngIf="activeBtn === 'call_now'"
        class="absolute bottom-[-10px] left-1/2 transform -translate-x-1/2 w-[100%] h-[2px] bg-[#E76B3F] rounded-[2px]"
      ></div>
    </div>
    <div class="relative">
      <button
        class="flex bg-[#F1F3F5] text-[#E76B3F] w-[auto] px-[10px] h-[5.5vh] justify-center items-center flex-shrink-0 border border-[#E76B3F] rounded-[4px] font-semibold !text-[14px] cursor-pointer"
        style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
        [ngClass]="{
          'bg-[#F1F3F5] text-[#E76B3F] border border-[#E76B3F]':
            activeBtn !== 'call_back',
          'bg-[#E76B3F] !text-[#F1F3F5]': activeBtn === 'call_back'
        }"
        (click)="changeBtn('call_back')"
      >
        <!-- Request  -->
        Request Call Back
      </button>
      <div
        *ngIf="activeBtn === 'call_back'"
        class="absolute bottom-[-10px] left-1/2 transform -translate-x-1/2 w-[100%] h-[2px] bg-[#E76B3F] rounded-[2px]"
      ></div>
    </div>
    <div class="relative">
      <button
        class="flex bg-[#F1F3F5] text-[#E76B3F] px-[10px] w-[auto] h-[5.5vh] justify-center items-center flex-shrink-0 border border-[#E76B3F] rounded-[4px] font-semibold text-[14px] cursor-pointer"
        style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
        [ngClass]="{
          'bg-[#F1F3F5] text-[#E76B3F] border border-[#E76B3F]':
            activeBtn !== 'drop_message',
          'bg-[#E76B3F] !text-[#F1F3F5]': activeBtn === 'drop_message'
        }"
        (click)="changeBtn('drop_message')"
      >
        Drop a Message
      </button>
      <div
        *ngIf="activeBtn === 'drop_message'"
        class="absolute bottom-[-10px] left-1/2 transform -translate-x-1/2 w-[100%] h-[2px] bg-[#E76B3F] rounded-[2px]"
      ></div>
    </div>
  </div>
  <div *ngIf="activeBtn === 'call_now'" class="pb-10">
    <div
      class="w-[100%] mt-[40px] px-[20px] flex justify-center text-[#E76B3F] text-[1rem] font-bold"
    >
      <p>
        “We’re just a call away! <br />Tap the button below to reach us
        instantly.”
      </p>
    </div>
    <div class="w-[90%] sm:w-[85%] md:w-[80%] mx-auto mt-6 px-4 md:px-8 flex justify-between">
      <div class="flex flex-col items-center w-full">
        <!-- Tabs Container -->
        <div class="flex space-x-6 sm:space-x-10">
          <!-- Phone Call Tab -->
          <div 
            (click)="selectTab('phone')" 
            [ngClass]="{'border-b-4 border-[#E76B3F]': selectedTab === 'phone', 'text-[#E76B3F]': selectedTab === 'phone'}"
            class="text-center cursor-pointer flex flex-col items-center py-4">
            <img src="assets/icons/call_icon.svg" alt="Phone Call" class="h-[50px] w-[50px] sm:h-[70px] sm:w-[70px]" />
            <div class="mt-2 sm:mt-4 text-sm sm:text-[1rem] font-bold">Phone Call</div>
          </div>
          
          <!-- WhatsApp Tab -->
          <div 
            (click)="selectTab('whatsapp')" 
            [ngClass]="{'border-b-4 border-[#E76B3F]': selectedTab === 'whatsapp', 'text-[#E76B3F]': selectedTab === 'whatsapp'}"
            class="text-center cursor-pointer flex flex-col items-center py-4">
            <div class="w-[50px] h-[50px] sm:w-[70px] sm:h-[70px] rounded-full flex justify-center items-center">
              <img src="assets/icons/whatsapp_icon.svg" alt="WhatsApp" class="h-[50px] w-[50px] sm:h-[70px] sm:w-[70px]" />
            </div>
            <div class="mt-2 sm:mt-4 text-sm sm:text-[1rem] font-bold">WhatsApp</div>
          </div>
        </div>
      
        <!-- Bottom Border Line -->
        <!-- <div class="mt-3 w-full">
          <hr *ngIf="selectedTab" class="border border-[#E76B3F] w-auto" />
        </div> -->
      </div>
    </div>
    
    <div
      class="flex items-center justify-center mt-5 !text-[#21252A] font-bold text-[1rem] leading-[-0.48px]"
    >
      <p class="cursor-pointer">Call Now!</p>
    </div>
  </div>

  <div *ngIf="activeBtn === 'call_back'" class="mt-[16px] ml-[28px] mr-[28px]">
    <p class="text-[#E76B3F] text-[14px] font-bold">
      "Submit your details, and we will call you at your preferred time."
    </p>
    <div
      class="w-[100%]"
      style="max-height: calc(68.5vh - 170px); overflow-y: auto"
    >
      <!-- Name fields -->
      <div class="flex justify-between mt-3">
        <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-2 w-[100%]">
          <div class="flex flex-col">
            <mat-form-field appearance="outline" class="">
              <mat-label>First Name</mat-label>
              <input
                matInput
                required
                id="firstName"
                formControlName="firstName"
                type="text"
                class="pl-[16px] h-[40px] rounded-[10px] py-[10px]"
              />
            </mat-form-field>
          </div>
          <div class="flex flex-col">
            <mat-form-field appearance="outline" class="w-[100%]">
              <mat-label>Last Name</mat-label>
              <input
                matInput
                required
                id="lastName"
                formControlName="lastName"
                type="text"
                class="pl-[16px] h-[40px] rounded-[10px] py-[10px]"
              />
            </mat-form-field>
          </div>
        </div>
      </div>
      <!-- Email -->
      <div class="flex flex-col">
        <mat-form-field appearance="outline" class="w-[100%] !h-[66px]">
          <mat-label>Email</mat-label>
          <input
            matInput
            required
            id="email"
            formControlName="email"
            type="email"
            class="bg-[#EFF8FF] text-[#21252A] border-[#1A4971] pl-[16px] h-[40px] rounded-[10px] py-[10px]"
          />
        </mat-form-field>
      </div>

      <!-- phone Number -->
      <div class="flex flex-col mt-[8px]">
        <mat-form-field appearance="outline" class="w-[100%] !h-[66px]">
          <mat-label>Phone</mat-label>
          <input
            matInput
            required
            id="phone"
            formControlName="phone"
            type="tel"
            class="bg-[#EFF8FF] text-[#21252A] border-[#1A4971] pl-[16px] h-[40px] rounded-[10px] py-[10px]"
            placeholder="Enter your phone number"
          />
        </mat-form-field>
      </div>
      <!-- Date & Time -->
      <div class="flex justify-between mt-[8px]">
        <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2 gap-2">
          <div class="flex flex-col">
            <mat-form-field appearance="outline" class="w-[100%] !h-[66px]">
              <mat-label>Date</mat-label>
              <input
                matInput
                [matDatepicker]="picker"
                required
                id="date"
                formControlName="date"
                type="text"
                class="bg-[#EFF8FF] text-[#21252A] border-[#1A4971] h-[40px] rounded-[10px] py-[10px]"
              />
              <mat-datepicker-toggle
                matIconSuffix
                [for]="picker"
              ></mat-datepicker-toggle>
              <mat-datepicker #picker></mat-datepicker>
            </mat-form-field>
          </div>
          <div class="flex flex-col">
            <mat-form-field appearance="outline" class="!h-[66px]">
              <mat-label>Time</mat-label>
              <input
                matInput
                required
                id="time"
                formControlName="time"
                type="time"
                class="bg-[#EFF8FF] text-[#21252A] border-[#1A4971] pl-[16px] h-[40px] rounded-[10px] py-[10px]"
              />
              <mat-icon matSuffix class="text-[#E76B3F]">access_time</mat-icon>
            </mat-form-field>
          </div>
        </div>
      </div>
      <!-- Comment Box -->
      <div class="flex flex-col mt-[8px]">
        <mat-form-field appearance="outline" class="w-[100%] !h-[84px]">
          <mat-label>Comment or Message</mat-label>
          <textarea
            matInput
            required
            id="comment"
            formControlName="comment"
            class="bg-[#EFF8FF] text-[#21252A] border-[#1A4971] pl-[16px] rounded-[10px] py-[10px] flex-shrink-0"
            placeholder="Write your notes here"
            rows="2"
          ></textarea>
        </mat-form-field>
      </div>

      <div class="flex justify-center">
        <button
          class="flex mt-[0.5rem] bg-[#E76B3F] text-[#F1F3F5] w-[80px] h-[38px] justify-center items-center rounded-[4px] mb-5 font-semibold text-[14px] cursor-pointer"
          style="box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25)"
        >
          Submit
        </button>
      </div>
    </div>
  </div>
  <!-- Drop a Message -->
  <div
    *ngIf="activeBtn === 'drop_message'"
    class="mt-[16px] h-[calc(100%-123px)] ml-[28px] mr-[28px] flex flex-col justify-between"
  >
    <p class="text-[#E76B3F] text-[14px] font-bold reading-[-0.42px]">
      "Send us a message, and we will respond as soon as possible."
    </p>

    <div class="flex-grow">
      <div class="w-[100%] h-[100%] flex flex-col justify-between">
        <div>
          <div class="grid grid-cols-2 md:grid-cols-2 lg:grid-cols-2">
            <div class="flex flex-col">
              <mat-form-field
                appearance="outline"
                class="w-[100%] !h-[66px] pr-2"
              >
                <mat-label>First Name</mat-label>
                <input
                  matInput
                  required
                  id="firstName"
                  formControlName="firstName"
                  type="text"
                  class="pl-[16px] h-[40px] rounded-[10px] py-[10px]"
                />
              </mat-form-field>
            </div>

            <div class="flex flex-col">
              <mat-form-field appearance="outline" class="w-[100%] !h-[66px]">
                <mat-label>Last Name</mat-label>
                <input
                  matInput
                  required
                  id="lastName"
                  formControlName="lastName"
                  type="text"
                  class="pl-[16px] h-[40px] rounded-[10px] py-[10px]"
                />
              </mat-form-field>
            </div>
          </div>
          <!-- Drop Message Email -->
          <div class="flex flex-col">
            <mat-form-field appearance="outline" class="w-[100%] !h-[66px]">
              <mat-label>Email</mat-label>
              <input
                matInput
                required
                id="email"
                formControlName="email"
                type="email"
                class="pl-[16px] h-[40px] rounded-[10px] py-[10px]"
                placeholder="Enter your email"
              />
            </mat-form-field>
          </div>

          <div class="flex flex-col">
            <mat-form-field appearance="outline" class="w-[100%]">
              <mat-label>Comment or Message</mat-label>
              <textarea
                matInput
                required
                id="comment"
                formControlName="comment"
                class="pl-[16px] rounded-[10px] py-[10px] flex-shrink-0"
                placeholder="Write your notes here"
                rows="2"
              ></textarea>
            </mat-form-field>
          </div>
        </div>
      </div>
    </div>

    <div class="flex justify-center mt-auto !pb-4">
      <button
        class="flex bg-[#E76B3F] text-[#F1F3F5] w-[80px] h-[38px] justify-center items-center rounded-[4px] font-semibold text-[14px] cursor-pointer"
        style="
          box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
          padding: 7.985px 15.97px;
        "
      >
        Submit
      </button>
    </div>
  </div>
</div>
